import {useGrpcRequestCallback} from '@aboutyou/data-fetcher';
import {DeferredElement} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/deferred_element.types';
import {HeroBrandsSection_BrandElement} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/sections.types';
import {HubPageService_HeroBrandElementLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/hub_page/service.grpc.lazy';
import {useFullSession} from '@aboutyou/user';
import {useCallback} from 'react';
import {useHubTypeFromSlug} from '../../../../../backend-services/HubPage/utils/useHubTypeFromSlug';
import {useTargetGroupIdentifier} from '../../../../../shared-deprecated/useTargetGroupIdentifier';
import {useReductionsStateRequestParameter} from '../../../../ReductionsState/useReductionsStateRequestParameter';

export const usePreloadBrandContent = (
  elements: HeroBrandsSection_BrandElement[],
) => {
  const getDeferredProducts = useGrpcRequestCallback(
    HubPageService_HeroBrandElementLazy,
  );
  const session = useFullSession();
  const targetGroup = useTargetGroupIdentifier();
  const reductionsState = useReductionsStateRequestParameter();
  const hubType = useHubTypeFromSlug();

  return useCallback(
    (index: number) => {
      if (elements[index]?.content?.$case !== 'deferred') {
        return;
      }

      const deferred = (
        elements[index]?.content as {
          $case: 'deferred';
          deferred: DeferredElement;
        }
      ).deferred;

      getDeferredProducts({
        session,
        targetGroup,
        hub: hubType,
        deferred,
        reductionsState,
      });
    },
    [
      elements,
      getDeferredProducts,
      hubType,
      reductionsState,
      session,
      targetGroup,
    ],
  );
};
